import React from "react";
import {useSelector} from "react-redux";
import AuthContainer from "../auth/AuthContainer";
import {Navigate} from "react-router-dom";

const PageLogin = () => {

    const { session, sessionTimedOut } = useSelector(
        state => state.auth
    )

    if(session && !sessionTimedOut) {
        return (
            <Navigate to="/"/>
        )
    }

    return (
        <div className="login-body">
            <AuthContainer/>
        </div>
    )

}

export default PageLogin;